import React, { useEffect, useRef, useState } from 'react';

import { styled } from '@material-ui/core';
import Paper from '@material-ui/core/Paper';
import Container from '@material-ui/core/Container';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import DatePicker from '@material-ui/lab/DatePicker';
import TextField from '@material-ui/core/TextField';
import Selector from '../../components/selector';
import Button from '@material-ui/core/Button';
import Table from '@material-ui/core/Table';
import TableContainer from '@material-ui/core/TableContainer';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import TablePagination from '@material-ui/core/TablePagination';
import TableHead from '@material-ui/core/TableHead';
import TableBody from '@material-ui/core/TableBody';

import { useAPI } from '../../utils/api';
import { makeStyles } from '@material-ui/styles';
import { useAuth } from '../../utils/auth';

const useStyles = makeStyles({
  root: {
    '&:last-of-type td': {
      borderBottom: 'none',
    },
  },
});

const MemberItemContainer = styled(Grid)({
  textAlign: 'center',
  borderLeft: '1px solid',
});

const MemberItemGrid = styled(Grid)({
  padding: 6,
  borderBottom: '1px solid',
  borderRight: '1px solid',
  display: 'block',
  alignItems: 'center',
  justifyContent: 'center',
  overflowWrap: 'anywhere',
});

const columns = [
  { id: 'checkoutDate', label: '結帳日' },
  { id: 'accountCode', label: '會員編號' },
  { id: 'name', label: '會員簡稱' },
  { id: 'totalShippingFee', label: '總運費' },
  {
    id: 'upStandardDeliveryFee',
    label: '達標運費',
  },
  {
    id: 'status',
    label: '狀態',
  },
  {
    id: 'monthlyFee',
    label: '月結手續費',
  },
  {
    id: 'referenceCode',
    label: '關聯編號',
  },
  {
    id: 'activityName',
    label: '活動名稱',
    minWidth: '200px',
  },
];

const SearchMenu = [
  {
    text: '會員名稱',
    value: '1',
  },
  {
    text: '會員編號',
    value: '2',
  },
];

/*const feeDatas = [
  {
    status: '達標', //狀態
    checkoutDate: '2021/05/04', //結帳日
    accountCode: 'K01508', //會員編號
    name: 'Jerry', //會員簡稱
    totalDeliveryFee: 1040, //總運費
    upStandardDeliveryFee: 2000, //達標運費
    notUpStandardFee: 100, //未達標月結手續費
    referenceCode: 'S1234', //關聯編號
    activityName: '超殺優惠', //活動名稱
  },
  {
    status: '達標', //狀態
    checkoutDate: '2021/05/04', //結帳日
    accountCode: 'K01509', //會員編號
    name: 'Derek', //會員簡稱
    totalDeliveryFee: 1040, //總運費
    upStandardDeliveryFee: 2000, //達標運費
    notUpStandardFee: 100, //未達標月結手續費
    referenceCode: 'S1236', //關聯編號
    activityName: '超殺優惠', //活動名稱
  },
];*/

const FeeMonthlyPage = () => {
  const api = useAPI();
  const auth = useAuth();
  const classes = useStyles();
  const [startDateValue, setStartDateValue] = useState(null);
  const [endDateValue, setEndDateValue] = useState(null);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [feeDatas, setFeeDatas] = useState([]);
  const listForm = useRef();
  const filterForm = useRef();
  const [shouldPageUpdated, setShouldPageUpdated] = useState(false);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const searchMonthlyFee = (event) => {
    event.preventDefault();
    const form = event.target;
    const formData = new FormData(form);

    /*if (
      formData.get('createTime') == null ||
      formData.get('createTime') === ''
    ) {
      dialog.openAlert({ message: '結帳日期為必填項目' });
      return;
    }*/

    const data = {
      memberId: auth.user.memberID,
      accountCode:
        formData.get('nameOrAccountCode') === '2'
          ? formData.get('keyWord')
          : '',
      name:
        formData.get('nameOrAccountCode') === '1'
          ? formData.get('keyWord')
          : '',
      startDate: formData.get('startDate'),
      endDate: formData.get('endDate'),
    };

    api
      .getFeeMonthly(data)
      .then((feeData) => {
        updateFeeData(feeData);
        setShouldPageUpdated(true);
      })
      .catch(() => {});
  };

  const downloadMonthlyFeeExcel = () => {
    const form = filterForm.current;
    const formData = new FormData(form);

    const data = {
      memberId: auth.user.memberID,
      accountCode:
        formData.get('nameOrAccountCode') === '2'
          ? formData.get('keyWord')
          : '',
      name:
        formData.get('nameOrAccountCode') === '1'
          ? formData.get('keyWord')
          : '',
      startDate: formData.get('startDate'),
      endDate: formData.get('endDate'),
    };

    api
      .downloadMonthlyFeeFile(data)
      .then((url) => {
        if (url !== '') {
          location.href = url;
        }
      })
      .catch(() => {});
  };

  const updateFeeData = (feeData) => {
    // if (!isUnmounted) {
    const rows = [];
    feeData.map((item) => {
      rows.push(item);
    });
    setFeeDatas(rows);
    // }
  };

  useEffect(() => {
    return () => {
      setShouldPageUpdated(false);
    };
  }, [shouldPageUpdated]);

  useEffect(() => {
    const dateNow = new Date();
    dateNow.setDate(dateNow.getDate() - 30);
    setStartDateValue(dateNow);
    setEndDateValue(new Date());
  }, []);

  return (
    <>
      <Paper
        elevation={4}
        sx={{
          paddingTop: { xs: 1, md: 2 },
          paddingBottom: { xs: 2, md: 4 },
          marginBottom: 4,
          maxWidth: '900px',
          marginLeft: 'auto',
          marginRight: 'auto',
        }}
      >
        <Container>
          <Typography variant="h6" gutterBottom display="inline" mr="2px">
            查詢條件
          </Typography>
          <Box
            ref={filterForm}
            component="form"
            noValidate
            onSubmit={searchMonthlyFee}
          >
            <Grid container spacing={{ xs: 1, md: 2 }}>
              <Grid item xs={12} sm={6} md={4}>
                <Selector
                  required
                  id="nameOrAccountCode"
                  name="nameOrAccountCode"
                  label=""
                  fullWidth
                  variant="standard"
                  size="small"
                  autoComplete="none"
                  placeHolder="條件"
                  defaultValue="1"
                  options={SearchMenu}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <TextField
                  required
                  id="keyWord"
                  name="keyWord"
                  label="關鍵字"
                  fullWidth
                  variant="standard"
                  size="small"
                  autoComplete="none"
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4}></Grid>
              <Grid item xs={12} sm={6} md={4}>
                <DatePicker
                  label="結帳起始日(查詢期間最多180天)"
                  value={startDateValue}
                  onChange={(newValue) => {
                    setStartDateValue(newValue);
                  }}
                  mask="____-__-__"
                  inputFormat={'yyyy-MM-dd'}
                  clearable={true}
                  clearText="清除"
                  cancelText="取消"
                  okText="確定"
                  renderInput={(parameters) => (
                    <TextField
                      id="startDate"
                      name="startDate"
                      label="結帳起始時間"
                      fullWidth
                      variant="standard"
                      size="small"
                      autoComplete="none"
                      {...parameters}
                    />
                  )}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <DatePicker
                  label="結帳結束日"
                  value={endDateValue}
                  onChange={(newValue) => {
                    setEndDateValue(newValue);
                  }}
                  mask="____-__-__"
                  inputFormat={'yyyy-MM-dd'}
                  clearable={true}
                  clearText="清除"
                  cancelText="取消"
                  okText="確定"
                  renderInput={(parameters) => (
                    <TextField
                      id="endDate"
                      name="endDate"
                      label="結帳結束時間"
                      fullWidth
                      variant="standard"
                      size="small"
                      autoComplete="none"
                      {...parameters}
                    />
                  )}
                />
              </Grid>

              <Grid
                container
                spacing={3}
                sx={{ margin: 'auto', width: '100%', justifyContent: 'center' }}
              >
                <Grid item xs={10} sm={4} sx={{ maxWidth: '200px' }}>
                  <Button
                    type="submit"
                    fullWidth
                    variant="contained"
                    color="primary"
                  >
                    搜尋
                  </Button>
                </Grid>
                <Grid item xs={10} sm={4} sx={{ maxWidth: '200px' }}>
                  <Button
                    type="button"
                    fullWidth
                    variant="contained"
                    color="warning"
                    onClick={downloadMonthlyFeeExcel}
                    sx={{ color: 'white' }}
                  >
                    匯出Excel
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </Box>
        </Container>
      </Paper>
      <Typography variant="body2" marginTop={2} marginBottom={2}>
        提醒: 達標之月結手續費為$0
      </Typography>
      <Typography variant="body2" marginBottom={1} textAlign="center">
        共找到 {feeDatas ? feeDatas.length : 0} 筆資料
      </Typography>
      <Box ref={listForm} component="form"></Box>
      <Paper
        sx={{ width: '100%', overflow: 'hidden', padding: 1 }}
        elevation={5}
      >
        <TableContainer sx={{ maxHeight: 440 }}>
          <Table stickyHeader aria-label="sticky table">
            <TableHead>
              <TableRow
                sx={{
                  display: { xs: 'none', sm: 'table-row' },
                }}
              >
                {columns
                  ? columns.map((column, index) => (
                      <TableCell
                        key={`${column.id}-${index}`}
                        align={column.align || 'center'}
                        sx={{
                          minWidth: column.minWidth || 'none',
                          padding: 1,
                          maxWidth: '100%',
                          whiteSpace: 'nowrap',
                        }}
                      >
                        {column.label}
                      </TableCell>
                    ))
                  : undefined}
              </TableRow>
            </TableHead>
            <TableBody>
              {feeDatas &&
                feeDatas
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((row, rowIndex) => {
                    return (
                      <TableRow
                        hover
                        role="checkbox"
                        tabIndex={-1}
                        key={`${rowIndex}`}
                        className={classes.root}
                      >
                        {feeDatas &&
                          columns.map((column, columnIndex) => {
                            return (
                              <TableCell
                                key={`${column.id}-${columnIndex}`}
                                align={column.align || 'center'}
                                sx={{
                                  display: {
                                    xs: 'none',
                                    sm: 'table-cell',
                                  },
                                  padding: 1,
                                  minHeight: '0',
                                  maxWidth: '100%',
                                  whiteSpace: 'nowrap',
                                }}
                              >
                                <Typography variant="body1">
                                  {row[column.id]}
                                </Typography>
                              </TableCell>
                            );
                          })}

                        <TableCell
                          sx={{
                            display: {
                              xs: 'block',
                              sm: 'none',
                              width: '100%',
                            },
                          }}
                        >
                          <MemberItemContainer
                            container
                            borderTop="3px solid"
                            fontWeight="bold"
                          >
                            <MemberItemGrid item xs={12}>
                              結帳日
                            </MemberItemGrid>
                          </MemberItemContainer>
                          <MemberItemContainer container>
                            <MemberItemGrid item xs={12}>
                              <Typography variant="body1">
                                {row['checkoutDate']}
                              </Typography>
                            </MemberItemGrid>
                          </MemberItemContainer>
                          <MemberItemContainer
                            container
                            borderTop="1px solid"
                            fontWeight="bold"
                          >
                            <MemberItemGrid item xs={12}>
                              會員編號
                            </MemberItemGrid>
                          </MemberItemContainer>
                          <MemberItemContainer container>
                            <MemberItemGrid item xs={12}>
                              <Typography variant="body1">
                                {row['accountCode']}
                              </Typography>
                            </MemberItemGrid>
                          </MemberItemContainer>
                          <MemberItemContainer
                            container
                            borderTop="1px solid"
                            fontWeight="bold"
                          >
                            <MemberItemGrid item xs={12}>
                              會員簡稱
                            </MemberItemGrid>
                          </MemberItemContainer>
                          <MemberItemContainer container>
                            <MemberItemGrid item xs={12}>
                              <Typography variant="body1">
                                {row['name']}
                              </Typography>
                            </MemberItemGrid>
                          </MemberItemContainer>
                          <MemberItemContainer
                            container
                            borderTop="1px solid"
                            fontWeight="bold"
                          >
                            <MemberItemGrid item xs={12}>
                              總運費
                            </MemberItemGrid>
                          </MemberItemContainer>
                          <MemberItemContainer container>
                            <MemberItemGrid item xs={12}>
                              <Typography variant="body1">
                                {row['totalShippingFee']}
                              </Typography>
                            </MemberItemGrid>
                          </MemberItemContainer>
                          <MemberItemContainer
                            container
                            borderTop="1px solid"
                            fontWeight="bold"
                          >
                            <MemberItemGrid item xs={12}>
                              達標運費
                            </MemberItemGrid>
                          </MemberItemContainer>
                          <MemberItemContainer container>
                            <MemberItemGrid item xs={12}>
                              <Typography variant="body1">
                                {row['upStandardDeliveryFee']}
                              </Typography>
                            </MemberItemGrid>
                          </MemberItemContainer>
                          <MemberItemContainer
                            container
                            borderTop="1px solid"
                            fontWeight="bold"
                          >
                            <MemberItemGrid item xs={12}>
                              狀態
                            </MemberItemGrid>
                          </MemberItemContainer>
                          <MemberItemContainer container>
                            <MemberItemGrid item xs={12}>
                              <Typography variant="body1">
                                {row['status']}
                              </Typography>
                            </MemberItemGrid>
                          </MemberItemContainer>
                          <MemberItemContainer
                            container
                            borderTop="1px solid"
                            fontWeight="bold"
                          >
                            <MemberItemGrid item xs={12}>
                              月結手續費
                            </MemberItemGrid>
                          </MemberItemContainer>
                          <MemberItemContainer container>
                            <MemberItemGrid item xs={12}>
                              <Typography variant="body1">
                                {row['monthlyFee']}
                              </Typography>
                            </MemberItemGrid>
                          </MemberItemContainer>
                          <MemberItemContainer
                            container
                            borderTop="1px solid"
                            fontWeight="bold"
                          >
                            <MemberItemGrid item xs={12}>
                              關聯編號
                            </MemberItemGrid>
                          </MemberItemContainer>
                          <MemberItemContainer container>
                            <MemberItemGrid item xs={12}>
                              <Typography variant="body1">
                                {row['referenceCode']}
                              </Typography>
                            </MemberItemGrid>
                          </MemberItemContainer>
                          <MemberItemContainer
                            container
                            borderTop="1px solid"
                            fontWeight="bold"
                          >
                            <MemberItemGrid item xs={12}>
                              活動名稱
                            </MemberItemGrid>
                          </MemberItemContainer>
                          <MemberItemContainer container>
                            <MemberItemGrid item xs={12}>
                              <Typography variant="body1">
                                {row['activityName']}
                              </Typography>
                            </MemberItemGrid>
                          </MemberItemContainer>
                        </TableCell>
                      </TableRow>
                    );
                  })}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          labelRowsPerPage="每頁顯示"
          rowsPerPageOptions={[5, 10, 25, 50, 100]}
          component="div"
          count={feeDatas ? feeDatas.length : 0}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Paper>
    </>
  );
};

export default FeeMonthlyPage;
